/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".product_list[_ngcontent-%COMP%]{background-color:red;width:160px;margin-right:10px}"];
export { styles as styles };

